import React from "react";

// A polished mobile phone frame that displays an app screenshot
// Uses a tall 9:19.5 aspect ratio, soft bezel and depth shadows.
export const PhoneFrame = ({ src, alt, className = "", style, compact = false }) => (
  <div
    className={`relative ${className}`}
    style={style}
  >
    <div
      className={`relative bg-[#0A1F1F] ring-1 ring-black/10 ${
        compact
          ? "rounded-[1.7rem] p-1 shadow-[0_18px_34px_-18px_rgba(10,40,40,0.28),0_6px_12px_-10px_rgba(10,40,40,0.16)]"
          : "rounded-[2.2rem] p-[5px] shadow-[0_24px_52px_-22px_rgba(10,40,40,0.34),0_8px_16px_-12px_rgba(10,40,40,0.18)]"
      }`}
    >
      {/* Notch */}
      <div
        className={`absolute left-1/2 z-20 -translate-x-1/2 rounded-full bg-black/90 ${
          compact ? "top-1.5 h-3 w-14" : "top-2 h-3.5 w-[4.5rem]"
        }`}
      />
      <div className={`overflow-hidden bg-[#EAF1EE] ${compact ? "rounded-[1.45rem]" : "rounded-[1.9rem]"}`}>
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className="block h-full w-full object-cover"
          style={{ aspectRatio: "9 / 19.5" }}
        />
      </div>
      {/* Side highlight */}
      <div
        className={`pointer-events-none absolute inset-0 ring-1 ring-white/5 ${
          compact ? "rounded-[1.7rem]" : "rounded-[2.2rem]"
        }`}
      />
    </div>
  </div>
);

export default PhoneFrame;
